import { render } from "./user.vue.js?vue&type=template&id=0acc7c4a!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./user.vue?vue&type=template&id=0acc7c4a"
import script from "./user.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./user.vue?vue&type=script&lang=js"
export * from "./user.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./user.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__